// extracted by mini-css-extract-plugin
module.exports = {"product_wrap":"Product_product_wrap__7HXJp","itemContainer":"Product_itemContainer__3k1xE","priceBlock":"Product_priceBlock__2vdNX"};